export const loaderActionTypes = {
  SHOW_LOADER: '..::SHOW LOADER::..',
  HIDE_LOADER: '..::HIDE LOADER::..',
};

/**
 * LoaderActions class
 *
 */
class LoaderActions {
  /**
   * showLoader
   *
   */
  showLoader() {
    return {
      type: loaderActionTypes.SHOW_LOADER,
    };
  }

  /**
   * hideLoader
   *
   */
  hideLoader() {
    return {
      type: loaderActionTypes.HIDE_LOADER,
    };
  }
}

export default new LoaderActions();
